import React from 'react';
import { LOGO_URL } from '../data/mock';

const Footer = () => {
  return (
    <footer className="border-t border-border bg-secondary/40 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid md:grid-cols-3 gap-8">
          <div className="flex items-start gap-3">
            <img src={LOGO_URL} alt="Logo" className="h-14 w-14 rounded-full object-cover ring-2 ring-primary/30" />
            <div>
              <div className="font-serif font-bold text-lg">Nokma Sani Union</div>
              <div className="text-sm text-muted-foreground">Ku’monganio Bil · Garo Hills District</div>
              <div className="text-xs text-muted-foreground mt-1">Estd: 07 February</div>
            </div>
          </div>
          <div>
            <div className="font-serif font-semibold mb-2">About</div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              A digital registry preserving the traditional governance authority of the Nokma Sani — issuing land documents, trade NOCs and other certificates for the A’khings of Garo Hills.
            </p>
          </div>
          <div>
            <div className="font-serif font-semibold mb-2">Contact</div>
            <p className="text-sm text-muted-foreground">Garo Hills District, Meghalaya</p>
            <p className="text-sm text-muted-foreground">contact@nokmasani.union</p>
          </div>
        </div>
        <div className="divider-ornament my-8">
          <span className="text-xs text-muted-foreground tracking-widest uppercase">Ku’monganio Bil</span>
        </div>
        <div className="text-center text-xs text-muted-foreground">
          © {new Date().getFullYear()} Nokma Sani Union. Traditional Administration & Local Self Governance Registry.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
